
<template>
  <div style="width: 100%; height: 100%;">
    <div style="width: 100%; height: 50px; line-height: 50px;">
      <table style="width: 100%;">
        <tr>
          <td style="font-size: 20px;">{{product.title}}</td>
          <td>
            <date-picker v-model="dateRange"  valueType="format" @change="dateRangeSelected" range></date-picker>
            <button class="btn btn-success" @click="getList">GET</button>
          </td>

        </tr>
      </table>
    </div>
    <div style="width: 100%; height: calc(100% - 100px); overflow-y: auto;">

      <div v-if="report !== false">
        <div class="report-title">
          {{report.product.title}} Trend Report {{report.title}}
        </div>

        <div class="report-section-header" style="padding: 15px;">
          <table class="inv-report">
            <tr style="border-top: 1px solid #dadada;">
              <td>Daily Out:</td>
              <td>{{report.dailyOut.toFixed(2).toLocaleString()}}</td>
              <td>{{report.info}}</td>
            </tr>
            <tr style="border-top: 1px solid #dadada;">
              <td>Current Stock:</td>
              <td>{{report.totalInventory}}</td>
              <td>{{report.lastingText}}</td>
            </tr>

<!--            <tr>-->
<!--              <td>Weekly Out:</td>-->
<!--              <td>{{report.weeklyOut.toFixed(2).toLocaleString()}}</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td>Monthly Out:</td>-->
<!--              <td>{{report.monthlyOut.toFixed(2).toLocaleString()}}</td>-->
<!--            </tr>-->
          </table>


        </div>
        <div v-if="report.inventories !== null && report.inventories.length > 0" style="padding: 15px;">
          <div class="report-section-header">Current Stock Inventories</div>
          <table class="inv-report">
            <tr>
              <th>ID</th>
              <th>Stocked In Time</th>
              <th>Location</th>
              <th>Current Stock</th>
              <th v-if="user.viewProductCost === true">Unit Cost</th>
              <th v-if="user.viewProductCost === true">Current Price</th>
              <th v-if="user.viewProductCost === true">Expected Margin</th>
              <th>BBD</th>
<!--              <th>Expected Days</th>-->
<!--              <th>Expected Ending Date</th>-->
            </tr>
            <tr v-for="inv in report.inventories" :key="'trend-inv-' + inv.id">
              <td>{{inv.id}}</td>
              <td>{{convertDate(inv.stockInTime)}}</td>
              <td>{{inv.area}} - {{inv.location}} - {{inv.section}}</td>
              <td>{{inv.balance.toLocaleString()}}</td>
              <td v-if="user.viewProductCost === true">£{{inv.unitPriceFloat.toLocaleString()}}</td>
              <td v-if="user.viewProductCost === true">£{{product.priceFloat.toFixed(2)}}</td>
              <td v-if="user.viewProductCost === true">{{getExpectedMargin(inv)}}</td>
              <td>{{inv.expiryDate}}</td>
<!--              <td :class="{'warning': inv.expectedNumberOfDays < 14}">{{inv.expectedNumberOfDays.toLocaleString()}} day<span v-if="inv.expectedNumberOfDays > 1">s</span></td>-->
<!--              <td>{{inv.expectedEndingDate}}</td>-->
            </tr>
          </table>
        </div>
        <div v-for="(reportItem, ri) in report.items"  :key="'report-container-' + ri">

          <div class="report-section-header">{{reportItem.title}}</div>
          <div class="report-container">
            <table class="report-table">
              <tr>
                <th>Date</th>
                <th v-for="(item, ii) in reportItem.items" :key="'report-item-header-' + ri + '-' + ii">{{item.title}}
                  <!--                <span v-if="item.dateStart !== null && item.dateStart.length > 0"><br/> {{item.dateStart}}</span>-->
                </th>
              </tr>
              <tr class="report-out">
                <td class="title"></td>
                <td v-for="(item, ii) in reportItem.items" :key="'report-item-header-out-graph-' + ri + '-' + ii" class="report-graph-td" style="background: white;">
                  <div class="report-item-graph-container">
                    <div class="report-item-graph" :style="{'height': item.outQuantity/reportItem.maxOut*100 + '%'}"></div>
                  </div>
                </td>
              </tr>
              <tr class="report-out">
                <td class="title">Out</td>
                <td v-for="(item, ii) in reportItem.items" :key="'report-item-header-out-' + ri + '-' + ii">{{item.outQuantity.toLocaleString()}}</td>
              </tr>
              <tr class="report-in">
                <td class="title">In</td>
                <td v-for="(item, ii) in reportItem.items" :key="'report-item-header-in-' + ri + '-' + ii">{{item.inQuantity.toLocaleString()}}</td>
              </tr>
              <tr class="report-balance" v-if="reportItem.title === 'Daily'">
                <td class="title">Stock</td>
                <td v-for="(item, ii) in reportItem.items" :key="'report-item-header-balance-' + ri + '-' + ii">{{item.balance.toLocaleString()}}</td>
              </tr>
              <!--            <template v-if="reportItem.title === 'Daily'">-->
              <!--              <tr class="report-balance">-->
              <!--                <td class="title">Prime</td>-->
              <!--                <td v-for="(item, ii) in reportItem.items" :key="'report-item-header-prime-' + ri + '-' + ii">{{(item.primeCost/100.0).toFixed(2)}}</td>-->
              <!--              </tr>-->
              <!--              <tr class="report-balance">-->
              <!--                <td class="title">Price</td>-->
              <!--                <td v-for="(item, ii) in reportItem.items" :key="'report-item-header-price-' + ri + '-' + ii">{{(item.sellingPrice/100.0).toFixed(2)}}</td>-->
              <!--              </tr>-->
              <!--              <tr class="report-balance">-->
              <!--                <td class="title">Margin</td>-->
              <!--                <td v-for="(item, ii) in reportItem.items" :key="'report-item-header-margin-' + ri + '-' + ii">{{(item.margin/100.0).toFixed(2)}}%</td>-->
              <!--              </tr>-->
              <!--            </template>-->
            </table>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; height: 50px;">
      <button class="btn btn-dark" @click="closeView">Close</button>
    </div>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {getProductTracking, getProductTrend} from "../../api/product";
import {showDialog, timeToLocaleDateShort} from "../../api/utils";

export default {
  name:'ProductTrend',
  props:{
    product:{
      type:Object,
      default: function(){return null;}
    },
    onLoaded: {
      type: Function,
      default: null,
    },
    onClose: {
      type: Function,
      default: null,
    }
  },
  components: {
    DatePicker,
  },
  data(){
    return {
      dateRange:null,
      items:[],
      report:false,
      user:auth.getUser(),

    }
  },
  created() {
  },
  mounted() {
    this.getTrends();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {

    convertDate: timeToLocaleDateShort,
    dateRangeSelected: function() {
      console.log("dateRangeSelected")
      console.log(this.$data.dateRange)

      if(this.$data.dateRange.length !== 2) {
        return;
      }

      if(this.$data.dateRange[0] > this.$data.dateRange[1]) {
        let temp = this.$data.dateRange[1];
        this.$data.dateRange[0] = this.$data.dateRange[1];
        this.$data.dateRange[1] = temp;
      }
    },
    getExpectedMargin: function(inv) {
      return ((this.product.price - inv.unitPrice)/inv.unitPrice * 100).toFixed(2)+ '% ' + '(£' + ( (this.product.price - inv.unitPrice)/100.0).toFixed(2) + ')' ;
    },
    getList: function() {
      let from = this.$data.dateRange[0];
      let to = this.$data.dateRange[1];
      let self = this;
      getProductTracking(this.product.id, from, to)
        .then(function(data) {
          if(data.success === true) {
            console.log(data.item);
            self.$data.items = data.item;

          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }

          showDialog(msg, "ERROR");
        })
    },
    getTrends: function() {
      let self = this;
      getProductTrend(this.product.id)
        .then(function(data) {
          if(data.success === true) {
            self.$data.report = data.item;
            console.log("loaded so refresh product");
            if(self.onLoaded !== null) {
              self.onLoaded(self.product.id);
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }

          showDialog(msg, "ERROR");
        })
    },
    closeView: function() {
      if(this.onClose != null) {
        this.onClose();
      }
    }

  }
}
</script>

<style scoped>
.report-title {
  font-size: 23px;
  font-weight: bold;
  padding: 20px;
}
.report-section-header {
  padding: 10px;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  margin-top: 20px;
}
.report-container {
  width: 100%;
  padding: 10px;
  overflow-x: auto;
}
.report-table th {
  padding: 5px;
  background: #dadada;
}
.report-table td {
  padding: 5px;
  border-left: 1px solid #b2b2b2;

}
.report-out td {
  background: #fff3f3;
  font-weight: bold;
  font-size: 1.2rem;
}
.report-in td {
  background: #e8f2ff;
}
.report-balance td {
  background: #deffda;
}

td.title {
  font-weight: bold;
}

.report-item-graph-container {
  height: 100px;
  width: 100%;
  position: relative;
  background: white;
}
.report-item-graph {
  width: 50%;
  position: absolute;
  bottom:0;
  left: 25%;
  background: red;
}
.report-graph-td {
  background: white;
}
.inv-report {
  font-size: 18px;
  padding: 10px;
}
.inv-report td{
  padding: 10px 20px;
}
.inv-report th{
  padding: 10px 20px;
  background: #dadada;
}
.inv-report tr {
  border-bottom: 1px solid #b2b2b2;
}
.warning {
  color:#e7344c;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/ItemView/ProductTrendView.vue